import { ChakraProvider } from "@chakra-ui/react";
import React from "react";
import { Outlet } from "react-router-dom";
import theme from "../theme";
import "../styles/tailwind.css";
import { PublicHeader } from "../components/public/PublicHeader";
import { PublicFooter } from "../components/public/PublicFooter";
import { AuthModalProvider } from "../components/public/auth/AuthModalContext";

const PublicLayout: React.FC = () => (
  <ChakraProvider theme={theme}>
    <AuthModalProvider>
      <div className="min-h-screen flex flex-col bg-surface font-body-md text-body-md text-on-surface antialiased">
        <PublicHeader />
        <div className="flex-1">
          <Outlet />
        </div>
        <PublicFooter />
      </div>
    </AuthModalProvider>
  </ChakraProvider>
);

export default PublicLayout;
